import { assertNever } from '@/utils/assertNever';
import React from 'react';

type NoOptionsProps =
  | { type: 'noOptions'; isShown: boolean }
  | { type: 'noOptionsFound'; searchValue: string; isShown: boolean };

export const NoOptions: React.FC<NoOptionsProps> = props => {
  if (!props.isShown) {
    return null;
  }

  if (props.type === 'noOptions') {
    return <div className="py-2 text-sm text-gray-400">No options available</div>;
  }

  if (props.type === 'noOptionsFound') {
    return (
      <div className="py-2 text-sm text-gray-400">
        No options found for &quot;{props.searchValue}&quot;
      </div>
    );
  }

  assertNever(props);
};
